import { gql } from '~src/generated/portal/gql';

const GENERATE_TOKEN = gql(`
  mutation generateToken {
    generateSingleUseToken {
      token
    }
  }
`);

export default GENERATE_TOKEN;
